var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19404 1.22063C6.3614 0.59953 5.21202 1.3863 5.49795 2.38164C5.78836 3.39253 5.61779 4.47926 5.03143 5.35404L3.85748 7.10542C3.29836 7.93955 3 8.91962 3 9.92212V10.0271C3 12.7736 5.23858 15 8 15C10.7614 15 13 12.7736 13 10.0271V7.11052C13 6.26728 12.0111 5.80663 11.3598 6.34646L10 7.4735V5.55149C10 4.14276 9.33313 2.81625 8.2 1.97101L7.19404 1.22063ZM8 14C6.75 14 5.5 13.5636 5.5 11.8182C5.5 10.4532 6.51931 9.1104 7.36222 8.41598C7.64036 8.18684 8 8.40335 8 8.76372V10.509C8 10.8694 8.36968 11.1114 8.69997 10.9673L9.80003 10.4873C10.1303 10.3431 10.5038 10.5854 10.4832 10.9452C10.4109 12.2052 10.0281 14 8 14Z",
    fill: "#8178EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFire);
export default __webpack_public_path__ + "static/media/ImgFire.6832bca8708b61e5e6158ca12a8a3e39.svg";
export { ForwardRef as ReactComponent };